import { EnvManager } from '@services/environment/environment.service';
import { createBrowserHistory, History } from 'history';

export const history: History = createBrowserHistory({
  basename: EnvManager.getBrowserHistoryName(),
});
